module.exports = __webpack_public_path__ + "static/img/auth-forget-mail-send.35242290.svg";